import { Optional } from '@vimeo/core/types/generic';

import { liveApplicationConfig } from '../../configs/LiveApplicationConfig';

// todo: Separate timing utils folder

export interface ITimestampTimeDifference {
  seconds: number;
  minutes: number;
  hours: number;
  days: number;
}

/**
 * Get current timestamp with accounting of actual server time + time skew.
 */
export function getAbsoluteNow(): number {
  return Date.now() + liveApplicationConfig.TIMING.CLOCK_SKEW;
}

export function getTwoDigitFormat(millis: number): string {
  try {
    const formatter = new Intl.DateTimeFormat([], {
      hour: '2-digit',
      minute: '2-digit',
    });

    return formatter.format(millis);
  } catch {
    return '00:00';
  }
}

/**
 * Format duration in format hh:mm:ss or mm:ss for short videos.
 */
export function formatDuration(millis: number, hasHours = true) {
  const totalSeconds = Math.floor(millis / 1000);

  const hours: number = Math.floor(totalSeconds / 3600);
  const minutes: number = Math.floor((totalSeconds % 3600) / 60);
  const seconds: number = totalSeconds % 60;

  const pad = (num: number) => String(num).padStart(2, '0');

  if (hasHours) {
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  return `${pad(minutes)}:${pad(seconds)}`;
}

/**
 * Try to get difference between two timestamps
 */
export function getDifferenceBetweenTwoTimeStamps(
  fromTimeStamp: number,
  toTimeStamp: number,
): ITimestampTimeDifference {
  const seconds: number = Math.floor((toTimeStamp - fromTimeStamp) / 1000);
  const minutes: number = Math.floor(seconds / 60);
  const hours: number = Math.floor(minutes / 60);
  const days: number = Math.floor(hours / 24);

  return { seconds, minutes, hours, days };
}

/**
 * transform date to timestamp
 */
export function toTimestamp(date: Optional<number | string>): Optional<number> {
  if (!date) {
    return null;
  }

  return typeof date === 'string' ? Math.floor(new Date(date).getTime() / 1000) : date;
}
